import styled from "@emotion/styled";

export const MaterialCardRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;

  flex-wrap: wrap;
`